export const LOAD_PROJECTS_SUCCESS = "LOAD_PROJECTS_SUCCESS";
export const LOAD_PROJECT_SUCCESS = "LOAD_PROJECT_SUCCESS";
export const LOAD_PROJECT_STATS_SUCCESS = "LOAD_PROJECT_STATS_SUCCESS";
export const STORE_PROJECT_SUCCESS = "STORE_PROJECT_SUCCESS";
export const STORE_PROJECT_FAILURE = "STORE_PROJECT_FAILURE";
export const UPDATE_PROJECT_SUCCESS = "UPDATE_PROJECT_SUCCESS";
export const UPDATE_PROJECT_FAILURE = "UPDATE_PROJECT_FAILURE";

export const ADD_PROJECT_MEMBER_SUCCESS = "ADD_PROJECT_MEMBER_SUCCESS";
export const ADD_PROJECT_MEMBER_FAILURE = "ADD_PROJECT_MEMBER_FAILURE";

export const REMOVE_PROJECT_MEMBER_SUCCESS = "REMOVE_PROJECT_MEMBER_SUCCESS";
export const REMOVE_PROJECT_MEMBER_FAILURE = "REMOVE_PROJECT_MEMBER_FAILURE";


/** WEBPACK FOOTER **
 ** ./src/container/ProjectContainer/constants.js
 **/